import React from 'react';
import { Modal } from 'react-bootstrap';
import { HiXMark, HiClock, HiInformationCircle } from 'react-icons/hi2';
import { Merma } from '../../../../types';
import './MermaDetail.scss';

interface MermaDetailModalProps {
  show: boolean;
  onHide: () => void;
  merma: Merma | null;
}

const MermaDetail: React.FC<MermaDetailModalProps> = ({ show, onHide, merma }) => {
  if (!merma) return null;

  const formatDateTime = (dateTime: string | Date) => {
    return new Date(dateTime).toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="mp-modal">
      <Modal.Header className="mp-modal-header">
        <div className="form-modal-title-container">
          <span className="form-modal-title">Información de la Merma</span>
        </div>
        <button className="mp-modal-close" onClick={onHide}>
          <HiXMark size={20} />
        </button>
      </Modal.Header>

      <Modal.Body className="mp-modal-body">
        {/* Product Information */}
        <div className="mp-summary-card">
          <div className="mp-summary-item">
            <span className="label">Ingrediente</span>
            <span className="value">{merma.ingredient_name}</span>
          </div>
          <div className="mp-summary-item">
            <span className="label">Almacén</span>
            <span className="value">{merma.storage_unit_name}</span>
          </div>
        </div>

        {/* Quantity */}
        <div className="mp-summary-card" style={{ marginTop: '12px' }}>
          <div className="mp-summary-item">
            <span className="label">Cantidad Desperdiciada</span>
            <span className="value" style={{ color: '#dc3545' }}>{merma.quantity} {merma.unidad_medida_acronym}</span>
          </div>
        </div>

        {/* Time Information */}
        <div className="merma-detail-rows">
          <div className="merma-detail-row">
            <HiClock size={16} style={{ color: 'var(--text-color)', opacity: 0.5, flexShrink: 0 }} />
            <div className="merma-detail-row__content">
              <span className="label">Fecha de Registro</span>
              <span className="value">{formatDateTime(merma.local_timestamp)}</span>
            </div>
          </div>

          {merma.user_name && (
            <div className="merma-detail-row">
              <HiInformationCircle size={16} style={{ color: 'var(--text-color)', opacity: 0.5, flexShrink: 0 }} />
              <div className="merma-detail-row__content">
                <span className="label">Responsable</span>
                <span className="value">{merma.user_name}</span>
              </div>
            </div>
          )}

          {merma.timestamp && (
            <div className="merma-detail-row">
              <HiClock size={16} style={{ color: 'var(--text-color)', opacity: 0.5, flexShrink: 0 }} />
              <div className="merma-detail-row__content">
                <span className="label">Última Actualización</span>
                <span className="value">{formatDateTime(merma.timestamp)}</span>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="mp-modal-footer">
        <button className="mp-modal-btn-cancel" onClick={onHide}>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MermaDetail;
